// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CopyCodeController from "./copy_code_controller"
application.register("copy-code", CopyCodeController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DropZoneController from "./drop_zone_controller"
application.register("drop-zone", DropZoneController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import GroceryListController from "./grocery_list_controller"
application.register("grocery-list", GroceryListController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IngredientReplaceController from "./ingredient_replace_controller"
application.register("ingredient-replace", IngredientReplaceController)

import InviteTypeController from "./invite_type_controller"
application.register("invite-type", InviteTypeController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MealTypeManagerController from "./meal_type_manager_controller"
application.register("meal-type-manager", MealTypeManagerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OptimisticDeleteController from "./optimistic_delete_controller"
application.register("optimistic-delete", OptimisticDeleteController)

import PantryCardController from "./pantry_card_controller"
application.register("pantry-card", PantryCardController)

import PantryDragController from "./pantry_drag_controller"
application.register("pantry-drag", PantryDragController)

import PantryDropZoneController from "./pantry_drop_zone_controller"
application.register("pantry-drop-zone", PantryDropZoneController)

import PantryQuickAddController from "./pantry_quick_add_controller"
application.register("pantry-quick-add", PantryQuickAddController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import RecipeFormController from "./recipe_form_controller"
application.register("recipe-form", RecipeFormController)

import RecipeImportController from "./recipe_import_controller"
application.register("recipe-import", RecipeImportController)

import RecipePickerController from "./recipe_picker_controller"
application.register("recipe-picker", RecipePickerController)

import RecipeSearchController from "./recipe_search_controller"
application.register("recipe-search", RecipeSearchController)

import SupabaseAuthController from "./supabase_auth_controller"
application.register("supabase-auth", SupabaseAuthController)

import SwipeGestureController from "./swipe_gesture_controller"
application.register("swipe-gesture", SwipeGestureController)

import TaskDragController from "./task_drag_controller"
application.register("task-drag", TaskDragController)

import TaskDropZoneController from "./task_drop_zone_controller"
application.register("task-drop-zone", TaskDropZoneController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)

import VoiceInputController from "./voice_input_controller"
application.register("voice-input", VoiceInputController)

import VoiceTranscribeController from "./voice_transcribe_controller"
application.register("voice-transcribe", VoiceTranscribeController)
